import React, { ComponentPropsWithRef, FC, forwardRef, MouseEvent } from 'react'
import block from 'bem-cn'

import { Loader } from '../Loader'

import './Button.scss'

const b = block('button')

export enum ButtonVariants {
  PRIMARY = 'primary',
  SECONDARY = 'secondary',
  TERTIARY = 'tertiary',
}

export enum ButtonSizes {
  SMALL = 'small',
  MEDIUM = 'medium',
  LARGE = 'large',
  MODAL = 'modal',
}

export type ButtonProps = ComponentPropsWithRef<'button'> & {
  text?: string
  variant?: ButtonVariants
  size?: ButtonSizes
  fullWidth?: boolean
  isActive?: boolean
  loading?: boolean
  uppercase?: boolean
  active?: boolean
}

export const Button: FC<ButtonProps> = forwardRef<HTMLButtonElement, ButtonProps>(
  (
    {
      disabled,
      onClick,
      className,
      fullWidth,
      type = 'button',
      text,
      isActive,
      variant = ButtonVariants.PRIMARY,
      size = ButtonSizes.SMALL,
      loading,
      children,
      onMouseLeave,
      uppercase,
      ...restProps
    },
    ref,
  ) => {
    const handleMouseLeave = (event: MouseEvent<HTMLButtonElement>) => {
      event.currentTarget?.blur()
      onMouseLeave?.(event)
    }

    return (
      <button
        ref={ref}
        className={b({ 'full-width': fullWidth, variant, size, loading, uppercase, isActive }).mix(className)}
        disabled={disabled ?? loading}
        onClick={onClick}
        type={type}
        onMouseLeave={handleMouseLeave}
        {...restProps}>
        {loading && <Loader className={b('loader')} />}
        <div className={b('text')}>{text || children}</div>
      </button>
    )
  },
)

Button.displayName = 'Button'

export default Button
